// extracted by mini-css-extract-plugin
module.exports = {"ctaWrap":"link_ctaWrap__DaIeD","tertiary":"link_tertiary__t8_Zy"};